const React = require('react');
const ButtonM = require('../../../../../dumb/Button/Decline');


module.exports = (props) => {
  return (
    <ButtonM
      {...props}
    >{props.children || 'Save'}</ButtonM>
  );
};
